import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';

/**
 * Compact transition into Real proof — copy only, no illustrative visual.
 */
export function Solution() {
  return <section className="bg-navy px-6 py-12 text-paper md:px-10 md:py-16" data-id="element-988" data-mp="lkka140iy0et">
      <div className="mx-auto max-w-3xl" data-id="element-989" data-mp="gkxtolpeg41s">
        <Reveal data-id="element-990" data-mp="gjwgaakwv5gw">
          <Eyebrow data-id="element-991" data-mp="gjefd0nb032n">The Reader-to-Revenue Build</Eyebrow>
          <h2 className="mt-3 font-serif text-3xl leading-[1.08] text-paper md:text-4xl" data-id="element-992" data-mp="vhovt2qgjtv3">
            We build what comes next.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-paper/70 md:text-lg" data-id="element-993" data-mp="qim048wdazzs">
            Author Leverage takes the ideas, frameworks, stories, language, and
            offers already inside your book and builds one connected
            Reader-to-Revenue System around them.
          </p>
          <p className="mt-6 font-serif text-xl leading-snug text-seaglass-light md:text-2xl" data-id="element-994" data-mp="1e97xn68qx1vj">
            One done-for-you service.
          </p>
          <div className="mt-4 space-y-2 text-base leading-relaxed text-paper/80 md:text-lg" data-id="element-995" data-mp="2pedzj1xm6v0p">
            <p data-id="element-996" data-mp="2ud7gx5g0v665">The reader experience is the mechanism.</p>
            <p data-id="element-997" data-mp="2udqvqdadlefy">Author leverage is the outcome.</p>
            <p data-id="element-998" data-mp="2zcjzhdzv1r2x">
              Revenue architecture and sales enablement make that leverage
              commercially useful.
            </p>
          </div>

          <p className="mt-8 font-serif text-xl leading-snug text-seaglass-light md:text-2xl" data-id="element-999" data-mp="33f8clxvlxk5p">
            Built on real revenue architecture experience.
          </p>
          <p className="mt-4 text-base leading-relaxed text-paper/80 md:text-lg" data-id="element-1000" data-mp="3db1l9667gti7">
            Built by a revenue architect involved in more than $500 million in
            thought-leadership revenue across coaching, training, events, and
            author-led businesses.
          </p>
        </Reveal>
      </div>
    </section>;
}